import {Station} from "../../stations/station.service.interface";
import {IServiceFactory} from "../../service-factory.interface";
import {NullableDate} from "../../../types/nullable-types";
import {IFlightsScheduleViewModel} from "./flights-schedule-view-model.interface";
import {IFlightScheduleFilter} from "./flight-schedule-filter.interface";
import {
    FlightScheduleAvailabilityStatusEnum,
    IFlightDateScheduleAvailability
} from "../../flights-schedule/flights-schedule.service.interface";

export class FlightScheduleModel implements IFlightsScheduleViewModel {
    constructor(private services: IServiceFactory,
                public readonly origin: Station,
                public  readonly destination: Station,
                private readonly _getMinAllowedDate: () => NullableDate,
                private readonly filter: IFlightScheduleFilter | null) {
        const time = this.services.time;
        this.datesRange = this.services.time.getDateRange(time.currentDate, time.addMonths(time.currentDate, 24));
    }

    readonly datesRange: Date[];
    getDateAvailability(date: Date): IFlightDateScheduleAvailability {
        const minAllowedDate = this._getMinAllowedDate();
        if(minAllowedDate && date.getTime() < minAllowedDate.getTime()) {
            return {
                status: FlightScheduleAvailabilityStatusEnum.NotAvailable
            };
        }

        if(this.filter && this.filter.shouldFilterOutDate(date)) {
            return {
                status: FlightScheduleAvailabilityStatusEnum.NotAvailable
            }
        }

        return this.services.flightsSchedule.getDaySchedule(this.origin, this.destination, date);

    }

    async getDateAvailabilityAsync(date: Date): Promise<IFlightDateScheduleAvailability> {
        const minAllowedDate = this._getMinAllowedDate();
        if(minAllowedDate && date.getTime() < minAllowedDate.getTime()) {
            return {
                status: FlightScheduleAvailabilityStatusEnum.NotAvailable
            };
        }

        if(this.filter && this.filter.shouldFilterOutDate(date)) {
            return {
                status: FlightScheduleAvailabilityStatusEnum.NotAvailable
            }
        }

        return await this.services.flightsSchedule.getDayScheduleAsync(this.origin, this.destination, date);
    }

}
